import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Grid,
  Box,
  Dialog,
  // DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Button as MuiButton,
  Divider,
  TextField as MuiTextField,
  Alert as MuiAlert,
  // IconButton,
} from "@mui/material";
import axios from "axios";
import { spacing } from "@mui/system";
// import Select from "./SelectBox";
import styled from "@emotion/styled";
// import { CalculateSharp } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);
const Alert = styled(MuiAlert)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Button = styled(MuiButton)(spacing);

const timeOut = (time) => new Promise((res) => setTimeout(res, time));

const validationSchema = Yup.object().shape({
  invoiceLabelShortCode: Yup.string().required("Required"),
  invoiceLabelDescription: Yup.string().required("Required"),
});
export default function ViewInvoiceLabelDialog(props) {
  const { viewInvoiceLabelDialog, setViewInvoiceLabelDialog } = props;
  // const [open, setOpen] = useState(false);

  // console.table(viewInvoiceLabelDialog.params);
  // console.log(viewInvoiceLabelDialog?.params?.invoiceLabelShortCode);

  const initialValues = {
    invoiceLabelId: viewInvoiceLabelDialog?.params?.invoiceLabelId,
    invoiceLabelShortCode:
      viewInvoiceLabelDialog?.params?.invoiceLabelShortCode,
    invoiceLabelDescription:
      viewInvoiceLabelDialog?.params?.invoiceLabelDescription,
  };

  var errorMessage = "";
  var submitInError = false;

  const handleSubmit = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting }
  ) => {
    try {
      const test = {
        invoiceLabelShortCode: values.invoiceLabelShortCode,
        invoiceLabelDescription: values.invoiceLabelDescription,
      };

      // console.table(test);
      // console.log(values.invoiceLabelId);
      const headers = {
        "Access-control-allow-origin": "*",
        "Access-Control-Allow-Headers":
          "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
        "Access-Control-Allow-Methods": "GET,POST,PUT",
      };

      axios
        .put("/api/v1/invoiceLabels/" + values.invoiceLabelId, test, {
          headers: headers,
        })
        .then((response) => {
          errorMessage = "Your data has been submitted successfully!";
          submitInError = false;
        })
        .catch(function (error) {
          if (error.response) {
            submitInError = true;
            if (
              error.response.data.includes(
                "Cannot insert duplicate key row in object"
              )
            ) {
            }
            var errTxt = error.response.data;
            var sb = errTxt.substring(
              errTxt.indexOf("The duplicate key value is"),
              errTxt.length - errTxt.indexOf("The duplicate key value is")
            );
            errorMessage =
              "Error submitting new Entity. There is already an existing value found in the database: " +
              sb.substring(28, sb.indexOf(")."));
          } else if (error.request) {
            submitInError = true;
          } else {
            submitInError = true;
          }
        });

      await timeOut(1500);
      resetForm();
      setStatus({ sent: true });
      setSubmitting(false);
    } catch (error) {
      setStatus({ sent: false });
      setErrors({ submit: error.message });
      setSubmitting(false);
    }
  };

  // const handleClick = () => {
  //   console.log("1");
  //   console.table(viewInvoiceLabelDialog);
  //   console.log("2");
  //   setOpen(true);
  // };

  return (
    <Dialog
      open={viewInvoiceLabelDialog.isOpen}
      //   onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {viewInvoiceLabelDialog.title}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            status,
          }) => (
            <Card mb={6}>
              <CardContent>
                {/* <Typography
                            variant="h6"
                            gutterBottom
                            marginBottom={10}
                          >
                            New Country Information
                          </Typography> */}

                {submitInError ? (
                  <Alert severity="error" my={3}>
                    {errorMessage}
                  </Alert>
                ) : errorMessage.length > 0 ? (
                  <Alert severity="success" my={3}>
                    Your data has been submitted successfully!
                  </Alert>
                ) : (
                  ""
                )}

                {isSubmitting ? (
                  <Box display="flex" justifyContent="center" my={20} mx={40}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <form onSubmit={handleSubmit}>
                    {/* <Typography variant="body2" gutterBottom>
                                Company Information
                              </Typography> */}
                    <Grid container spacing={6}>
                      <TextField
                        name="invoiceLabelId"
                        // inputProps={{ maxLength: 10 }}
                        label="invoiceLabelId"
                        value={values.invoiceLabelId}
                        type="hidden"
                      />
                      <Grid item md={6} xs={12}>
                        <TextField
                          name="invoiceLabelShortCode"
                          label="Short Code"
                          value={values.invoiceLabelShortCode}
                          error={Boolean(
                            touched.invoiceLabelShortCode &&
                              errors.invoiceLabelShortCode
                          )}
                          fullWidth
                          helperText={
                            touched.invoiceLabelShortCode &&
                            errors.invoiceLabelShortCode
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="invoiceLabelShortCode"
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={6}>
                      <Grid item md={12} xs={12}>
                        <TextField
                          name="invoiceLabelDescription"
                          label="Description"
                          value={values.invoiceLabelDescription}
                          error={Boolean(
                            touched.invoiceLabelDescription &&
                              errors.invoiceLabelDescription
                          )}
                          fullWidth
                          helperText={
                            touched.invoiceLabelDescription &&
                            errors.invoiceLabelDescription
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="invoiceLabelDescription"
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      mt={3}
                      // onClick={() => setOpen(false)}
                      my={2}
                      mr={4}
                      onClick={viewInvoiceLabelDialog.onConfirm}
                    >
                      Change Invoice Label
                    </Button>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      mt={3}
                      //   onClick={() => window.location.reload(false)}
                      my={2}
                      // marginLeft={2}
                      onClick={() =>
                        setViewInvoiceLabelDialog({
                          ...viewInvoiceLabelDialog,
                          isOpen: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </form>
                )}
              </CardContent>
            </Card>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

//   <IconButton onClick={(e) => onButtonClick(e, params.row)}>
//     <DeleteIcon />
//   </IconButton>;
